import { useEffect, useState } from "react";
import { useAuth } from '../AuthContext';
import Loading from "./Loading";
import packageJson from '../../package.json';
import LoginRequired from "./LoginRequired";

const baseUrl = packageJson.apiUrl;

export async function dataFetcher({ action, params = null, token = null }) {
    let url = baseUrl + action;
    const query = [];
    if (typeof params === 'object' && params !== null) {
        for (const key in params) {
            if (params[key] !== null && typeof params[key] !== 'undefined') {
                query.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]));
            }
        }
    }
    if (query.length) {
        url += '?' + query.join('&');
    }
    const headers = { Accept: 'application/json' };
    if (token) {
        headers.Authorization = 'Bearer ' + token;
    }
    return fetch(url, { headers });
}

export default function DataLoader({ children, action, params, setData = null, onRedirect = null, requireLogin = false, dependencies = [] }) {
    const [loading, setLoading] = useState(true);
    const [unauthorized, setUnauthorized] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0); // Increment to refresh data
    const { token } = useAuth();
    useEffect(() => {
        let handled = false;
        if (requireLogin && !token) {
            setUnauthorized(true);
            setLoading(false);
            return;
        }
        setUnauthorized(false);
        setLoading(true);
        dataFetcher({ action, params, token }).then(r => {
            if (r.status === 401) {
                setUnauthorized(true);
                return null;
            }
            if (r.redirected && typeof onRedirect === 'function') {
                const newUrl = r.url.indexOf(baseUrl) === 0 ? r.url.replace(baseUrl, '') : r.url;
                handled = !!onRedirect(newUrl);
            }
            return r.json();
        }).then(data => {
            if (handled || !data) {
                return;
            }
            typeof setData === 'function' && setData(data);
            setLoading(false);
        });
        // ESlint does not understand this way of passing dependencies
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshKey, ...dependencies]);
    if (unauthorized) {
        return <LoginRequired onLogin={ () => { setRefreshKey(refreshKey + 1); } } />;
    }

    return loading ? <Loading /> : children;
}